import Env from '../base/env'
import Channels from '../base/channels'
import {TimelineLite} from 'gsap'
import Hammer from 'hammerjs'

export default class Slideshow
{
    constructor(view = '')
    {
        // Dom
        this.view = view
        this.$collection = this.view.querySelector('.jsCollection')
        this.$items = this.view.querySelectorAll('.jsItem')
        this.$previous = this.view.querySelector('.jsPrevious')
        this.$next = this.view.querySelector('.jsNext')
        this.$triggers = this.view.querySelectorAll('.jsAnchor')
        // Touch
        this.indicator = false;
        this.hammerView = new Hammer(this.view)
        this.hammerView.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
        // States
        this.OLD_INDEX = 0
        this.CURRENT_INDEX = 0
        this.TOTAL = this.$items.length - 1
        this.DIRECTION = 0
        this.IS_MOVING = false
        // Fns
        this.funcReset = this.reset.bind(this)
        this.setup()
    }

    destroy()
    {
        Channels.removeListener('window::smartresize', this.funcReset);
    }

    events()
    {

        if(this.$previous !== null) {
            this.$previous.addEventListener('click',()=>{

                this.goToPrevious()
            })
        }

        if(this.$next !== null) {
            this.$next.addEventListener('click',()=>{
                this.goToNext()
            })
        }

        // SWIPE
        this.hammerView.on('swipeleft' , (ev)=>
        {
            this.goToNext()
        })

        this.hammerView.on('swiperight' , (ev)=>
        {
            this.goToPrevious()
        })

        if(this.$triggers.length)
        {
            for(let i = 0; i < this.$triggers.length; i++) {
                const $trigger = this.$triggers[i]
                $trigger.addEventListener('click',()=>{

                    this.goTo(i)
                })
            }
        }

        Channels.on('window::smartresize',this.funcReset)
    }

    finalize()
    {
        if(this.$items.length > 0)
        {
            const $itemActive = this.$items[this.CURRENT_INDEX]
            for(let i = 0; i<this.$items.length; i++){
                const item = this.$items[i]
                if(item.classList.contains('disabled') == true) item.classList.remove('disabled')
                if(item.classList.contains('enabled') == true) item.classList.remove('enabled')
                item.style.zIndex = 0
                if(i != this.CURRENT_INDEX) {
                    item.classList.add('disabled')
                }
            }
            $itemActive.classList.add('enabled')
            $itemActive.style.zIndex = 1
        }
        this.updateTrigger()
    }

    goTo(index)
    {
        if(this.IS_MOVING == false)
        {
            if(index > this.CURRENT_INDEX) {
                this.DIRECTION = 1
            } else {
                this.DIRECTION = -1
            }
            this.CURRENT_INDEX = index
            this.move()
        }
    }

    goToPrevious()
    {
        if(this.IS_MOVING == false)
        {
            this.DIRECTION = -1
            this.CURRENT_INDEX--
            if(this.CURRENT_INDEX < 0) {
                this.CURRENT_INDEX = this.TOTAL
            }
            this.move()
        }

    }

    goToNext()
    {
        if(this.IS_MOVING == false)
        {
            this.DIRECTION = 1
            this.CURRENT_INDEX++
            if(this.CURRENT_INDEX > this.TOTAL) {
                this.CURRENT_INDEX = 0
            }
            this.move()
        }
    }

    move()
    {
        const $current = this.$items[this.OLD_INDEX]
        const $next = this.$items[this.CURRENT_INDEX]
        let timeline = new TimelineLite({ onComplete : this.twIsComplete.bind(this) })
        const viewport = Env.framework.toolbox.getViewport()
        let clipFrom, clipTo;
        let $nextMedia = $next.querySelector('.bg')
        // Context
        const dimensions = this.$collection.getBoundingClientRect()

        if(this.DIRECTION > 0) {
            clipFrom = `rect(0px,${dimensions.width}px,${dimensions.height}px,${dimensions.width}px)`
            clipTo = `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)`
        } else {
            clipFrom = `rect(0px,0px,${dimensions.height}px,0px)`
            clipTo = `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)`

        }

        if(this.OLD_INDEX != this.CURRENT_INDEX) {
            this.IS_MOVING = true;
            this.updating()
            timeline.kill()
            timeline.call(()=>{
                this.updateProgress()
                TweenLite.set($next , { clip : clipFrom })
                clean()
            })
            timeline.add([
                TweenLite.to($next , .5 , { clip : clipTo , ease : Power3.easeInOut }),
                TweenLite.fromTo($nextMedia , 1 , { scale : 1.14 } , { scale: 1 , ease : Power3.easeOut , delay : .2 }),
            ])
            timeline.add(()=>{
                TweenLite.set($next , { clearProps : 'clip' })
                TweenLite.set($current , { clearProps : 'clip' })
                TweenLite.set($nextMedia , { clearProps : 'scale' })
            })

            function clean()
            {
                $current.style.zIndex = 2
                $next.style.zIndex = 3
                $next.classList.remove('disabled')
                $next.classList.add('enabled')
            }
        }
    }

    reset()
    {
        console.log('reset');
    }

    setup()
    {
        this.events()
        this.updating()
        this.finalize()
    }

    twIsComplete()
    {
        this.IS_MOVING = false;
        this.OLD_INDEX = this.CURRENT_INDEX
        this.finalize()
    }

    updateTrigger()
    {
        if(this.$triggers.length > 0)
        {
            const $triggerActive = this.$triggers[this.CURRENT_INDEX]
            for(let i = 0; i<this.$triggers.length; i++){
                const $trigger = this.$triggers[i]
                $trigger.classList.remove('is--active')
            }
            $triggerActive.classList.add('is--active')
        }
        if(context.namespace == 'product')
        {

            Env.$mainNav.querySelector("li[data-slug='collection']").classList.add('is--active')
        }
    }

    updateProgress()
    {
        this.updateTrigger()
    }

    updating()
    {
        if(this.CURRENT_INDEX > 0) {
            this.view.classList.add('is--scrolling')
        } else {
            this.view.classList.remove('is--scrolling')
        }
    }
}